<template>
    <span class="overline">
      <component :is="'jo' + item.name" v-for="item in data" v-bind:key="item.index" v-bind:data="item.data"></component>
    </span>
</template>

<script>
  export default {
    props: [
      'data'
    ],
  }
</script>

<style>
  .overline{
    text-decoration: overline;
  }
</style>



// WEBPACK FOOTER //
// src/components/maincontent/body/common/overline.vue